module.exports = __webpack_public_path__ + "static/media/logo.ccc66c1b.png";